<template>
  <!-- 保持原有模板不变 -->
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>广告编辑</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card" style="margin-top:20px">
      <el-form
          :inline="false"
          :model="ruleForm"
          :rules="rules"
          ref="formForRef"
          label-width="80px"
          autocomplete="on"
          size="mini"
      >
        <el-row :gutter="24">
          <el-col :span="7">
            <el-form-item label="标题" prop="ad_name">
              <el-input placeholder="请输入标题"  v-model="ruleForm.ad_name" type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="所属区域">
              <el-cascader
                  ref="cascaderAddr"
                  style="width: 90%"
                  v-model="areaList"
                  :props="propsdata"
                  :key="isResouceone"
                  @change="handleChangeAddress"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="开始日期" size="small">
              <el-date-picker clearable type="date" placeholder="选择开始日期" v-model="addForm.start_time" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="位置" prop="position_id">
              <el-select v-model="ruleForm.position_id" style="width: 200px;" placeholder="请选择位置"  @change="handleIsopenSelect">
                <el-option :key="item.id"  v-for="item in cateMenus" :label="item.pid>0?'|--'+item.name:item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="所属商家" >
              <el-input width="400" placeholder="请输入所属商家" @click.native="chooseM" v-model="ruleForm.shop_name" type="text" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item label="图片">
              <i class="el-icon-camera" style="font-size:80px;" v-show="!ruleForm.ad_code" @click="showImgDoc(1,'')"></i>
              <el-image class="main_image"
                        v-show="ruleForm.ad_code" :src="ruleForm.ad_code" @click="showImgDoc(1,'')"></el-image>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="图片URL">
              <el-input v-model="ruleForm.ad_code"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="图片">
              <el-upload
                  class="upload-demo"
                  drag
                  action="#"
                  :before-upload="handleBeforeUpload"
                  :on-success="uploadSuccess"
                  :auto-upload="false"
                  :on-change="uploadFile"
                  :file-list="fileList"
                  list-type="picture"
                  multiple
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <!-- 卡片 -->
            <div style="border: 1px solid #ccc;">
              <Toolbar
                  style="border-bottom: 1px solid #ccc"
                  :editor="editor"
                  :defaultConfig="toolbarConfig"
                  :mode="mode"
              />
              <Editor
                  style="height: 300px; overflow-y: hidden;"
                  v-model="html"
                  :defaultConfig="editorConfig"
                  :mode="mode"
                  @onCreated="onCreated"
              />
            </div>
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <eShop  :formData="formData"
            :visible.sync="visible"
            :title="title"
            :closeForm="closeForm"
    />
    <eDocList :formData="formData1"
              :visible.sync="visible1"
              :title="title1"
              :closeForm="closeForm1"
    />
  </div>
</template>

<script>
import eDocList from "../common/eDocList";
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import axios from 'axios'
import moment from 'moment'     //日期时间转换
import eShop from "../common/eShopList";
import CryptoJS from "crypto-js";

export default {
  name:'adForm',
  components: { Editor, Toolbar,eShop,eDocList  },
  data() {
    // 核心修复：提前保存 Vue 实例的 this 引用
    const _this = this;

    return {
      formData:{},
      title:'',
      visible:false,

      formData1:{},
      title1:'',
      visible1:false,
      type_img:1,

      access_token:sessionStorage.getItem('token'),
      company_id:sessionStorage.getItem('company_id'),
      baseUrl:'/api/',
      fileList:[],
      isShowShop:false,
      ruleForm:{
        url:'',
        shop_name:'',
        shop_id:'',
        ad_id:'',
        ad_name:'',
        ad_link:'',
        position_id:'',
        ad_code:'',
      },
      addForm:{
        start_time:"",
        province_id:'',
        city_id:'',
        district_id:''
      },
      cateMenus:[],
      editor: null,
      html: '<p>hello</p>',
      toolbarConfig: { },
      editorConfig: {
        placeholder: '请输入内容...',
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          //配置上传图片
          uploadImage: {
            customUpload: this.uploadImg
          }
        }
      },
      mode: 'default', // or 'simple'
      rules: {
        ad_name:[
          { required: true, message: "请输入标题", trigger: 'change' }
        ],
        position_id:[
          { required: true, message: "请选择分类", trigger: 'change' }
        ],
      },
      areaList:[],
      isResouceone: false,
      propsdata: {
        // 懒加载地区列表
        lazy: true,
        // 核心修复：使用提前保存的 _this 代替内部的 this
        lazyLoad(node, resolve) {
          console.log(node)

          setTimeout(() => {
            // 第一級
            if (node.level == 0) {
              // 使用 _this 访问 Vue 实例的 $axios
              _this.$axios.regionList({
                access_token:sessionStorage.getItem('token'),
                company_id:sessionStorage.getItem('company_id'),
                parent_id:1
              }).then((res)=>{
                if(res.code==200){
                  const nodes = res.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }));
                  resolve(nodes);
                }
              })
            }
            // 第二級
            if (node.level == 1) {
              _this.$axios.regionList({
                access_token:sessionStorage.getItem('token'),
                company_id:sessionStorage.getItem('company_id'),
                parent_id:node.value
              }).then((res)=>{
                if(res.code==200){
                  const nodes = res.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }));
                  resolve(nodes);
                }
              })
            }
            if (node.level == 2) {
              _this.$axios.regionList({
                access_token:sessionStorage.getItem('token'),
                company_id:sessionStorage.getItem('company_id'),
                parent_id:node.value
              }).then((res)=>{
                if(res.code==200){
                  const nodes = res.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                    leaf: true,
                  }));
                  resolve(nodes);
                }
              });
            }
          }, 100);
        },
      },
    }
  },
  mounted() {
    this.getAdPoistionTree();
    let _this=this;
    _this.uri = _this.urlParse();
    console.log('uri----', _this.uri.searchParams)
    _this.ruleForm.ad_id = _this.uri.searchParams.ad_id;
    if (_this.ruleForm.ad_id > 0) {
      _this.getOne();
    }
  },
  methods: {
    showImgDoc(type,index){
      console.log(index)
      this.type_img=type;
      this.title1="图片选择";
      this.visible1=true;
    },
    closeForm1(){
      console.log('this.formData1---',this.formData1)
      if(this.type_img==1){
        this.ruleForm.ad_code=this.formData1.url;
      }
      this.visible1=false;
    },
    closeForm(){
      this.ruleForm.shop_id=this.formData.id;
      this.ruleForm.shop_name=this.formData.name;
      this.title="";
      this.visible=false;
    },
    chooseShop(id,...params){
      this.ruleForm.shop_id=id;
      this.ruleForm.shop_name=params[0];
    },
    chooseM(){
      this.title='选择商家';
      this.visible=true;
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      this.fileList.splice(index, 1);
    },
    handleChangeAddress(row){     // 更改时调用
      console.log(row)
      let _this=this;
      const checkedNode =  this.$refs["cascaderAddr"].getCheckedNodes();
      _this.addForm.province_id=checkedNode[0].path[0];
      _this.addForm.city_id=checkedNode[0].path[1];
      _this.addForm.district_id=checkedNode[0].path[2];
    },
    submitForm(formName){
      console.log(formName)
      let _this=this;
      this.$refs.formForRef.validate((valid) => {
        if (valid) {
          let params={
            ad_id: _this.ruleForm.ad_id,
            shop_id:_this.ruleForm.shop_id,
            access_token:sessionStorage.getItem('token'),
            company_id:sessionStorage.getItem('company_id'),
            ad_name:_this.ruleForm.ad_name,
            position_id:_this.ruleForm.position_id,
            ad_code: _this.ruleForm.ad_code,
            link: _this.ruleForm.url,
            content: _this.ruleForm.content,
            summary: _this.ruleForm.summary,
            ishot:_this.ruleForm.ishot?1:0,
            recommond:_this.ruleForm.recommond?1:0,
            istop:_this.ruleForm.istop?1:0,
            upload_time:_this.ruleForm.upload_time,
            province_id:_this.addForm.province_id,
            city_id:_this.addForm.city_id,
            district_id:_this.addForm.district_id,
            start_time:_this.addForm.start_time
          };
          console.log('params------',params)
          if( _this.ruleForm.ad_id){
            this.$axios.adUpdate(params).then((res)=>{
              if(res.code==200){
                this.$message({
                  message:'修改成功！',
                  type:'success',
                  offset:225,
                  duration:4000,
                  onClose:()=>{
                    this.$router.push('/adList')
                  }
                });
              }
              console.log(res);
            });
          }else{
            this.$axios.adSave(params).then((res)=>{
              if(res.code==200){
                this.$message({
                  message:'添加成功！',
                  type:'success',
                  offset:225,
                  duration:4000,
                  onClose:()=>{
                    this.$router.push('/adList')
                  }
                });
              }
              console.log(res);
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getOne(){
      let _this=this;
      let param={
        access_token: _this.access_token,
        company_id: _this.company_id,
        ad_id:_this.ruleForm.ad_id
      };
      this.$axios.adOne(param).then((res)=>{
        if(res.code==200){
          let item=res.data;
          _this.addForm.province_id=item.province_id;
          _this.addForm.city_id=item.city_id;
          _this.addForm.district_id=item.district_id;
          _this.areaList=[item.province_id,item.city_id,item.district_id];
          _this.ruleForm.ad_name=item.ad_name;
          _this.ruleForm.ad_id=item.ad_id;
          _this.ruleForm.position_id= item.position_id;
          _this.ruleForm.ad_code=item.ad_code;
          _this.ruleForm.shop_id=item.shop_id;
          _this.ruleForm.shop_name=item.shop!=null?item.shop.name:'';
          _this.addForm.start_time=item.start_time?moment(item.start_time*1000).format('yyyy-MM-DD'):'';

          if(_this.ruleForm.ad_code!=''&&_this.ruleForm.ad_code!=null){
            var img={
              name:_this.ruleForm.ad_name,
              url:_this.ruleForm.ad_code
            }
            console.log('fileList---',img)
            _this.fileList.push(img);
          }
        }
        console.log(res);
      });
    },
    async uploadFile (item) {
      let _this=this;
      let file = item.raw;

      let file_md5, file_sha1;
      await this.calculateMD5(file).then(md5 => {
        file_md5 = md5;
        console.log('MD5:', md5)
      });
      await this.calculateSHA1(file).then(sha1 => {
        file_sha1 = sha1;
        console.log('SHA1:', sha1);
      });

      // 获取文件名
      const fileName = file.name;
      // 获取文件大小
      const fileSize = file.size;
      // 获取文件后缀
      const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);

      console.log('文件名称：', fileName);
      console.log('文件后缀：', fileExtension);
      console.log('文件大小：', fileSize);
      let param_1 = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        md5: file_md5,
        sha1: file_sha1,
        size: fileSize
      };
      this.$axios.uploadOne(param_1).then(res => {
        if (res.code == 200) {
          //文件已经存在
          _this.ruleForm.ad_code = res.data.url;
          var img = {
            name: res.data.name,
            url: res.data.url
          }
          _this.fileList.push(img);
        } else {
          let param = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id')
          };
          this.$axios.getAliJsonCmp(param).then(res => {
            let data = res['data'];
            console.log('aliyun', data);
            let suffix = _this.get_suffix(file.name);
            let autoname = _this.Ymdhis();
            let key = data['dir'];
            let host = data['host'];
            let path = data['path'] != null && data['path'] != undefined ? data['path'] : '';
            let request = new FormData();
            request.append('name', file.name);
            request.append("key", key + path + autoname + suffix);//文件名字，可设置路径
            request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
            request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
            request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
            request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
            request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
            request.append('file', file);//需要上传的文件 file
            console.log('aliyun5555', request);
            axios.post(host, request, {headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
              //请求成功，触发then中的函数
              console.log('upload -res--------', res)
              var fileurl = res.data.filename; //上传完成后的文件oss地址
              var fullurl = host + '/' + fileurl;
              _this.ruleForm.ad_code = fullurl;
              var img = {
                name: fileName,
                url: fullurl
              }
              _this.fileList.push(img);
              //更新上传资料
              let upload_params = {
                access_token: sessionStorage.getItem('token'),
                company_id: sessionStorage.getItem('company_id'),
                name: fileName,
                size: fileSize,
                ext: fileExtension,
                md5: file_md5,
                sha1: file_sha1,
                path: fileurl,
                url: fullurl,
                status: 1,
              };
              console.log('upload---save params', upload_params)
              _this.$axios.uploadSave(upload_params).then(resu => {
                console.log('upload---save', resu)
              });
            })
                .catch(error =>
                    console.log(error)
                )
          });
        }
      });
    },
    async readFileAsBinaryString(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
        reader.readAsBinaryString(file);
      });
    },
    async  calculateMD5(file) {
      return  this.readFileAsBinaryString(file).then(binaryString => {
        const words = CryptoJS.lib.WordArray.create(binaryString);
        return CryptoJS.MD5(words).toString();
      });
    },
    async calculateSHA1(file) {
      return  this.readFileAsBinaryString(file).then(binaryString => {
        const words = CryptoJS.lib.WordArray.create(binaryString);
        return CryptoJS.SHA1(words).toString();
      });
    },
    resetForm(formName){
      this.$refs[formName].resetFields();
    },
    handleBeforeUpload(file) {
      console.log(file);
    },
    uploadSuccess(res){
      console.log(res)
    },
    handleIsopenSelect(){},
    getAdPoistionTree(){
      let _this=this;
      let param={
        access_token:sessionStorage.getItem('token'),
        company_id:sessionStorage.getItem('company_id')
      };
      console.log('lu------',param);
      this.$axios.adPositionTable(param).then((res)=>{
        if(res.code==200){
          _this.cateMenus=res.data;
        }
        console.log(res);
      });
    },
    uploadImg(file, insertFn){
      let _this=this;
      let param={
        access_token: sessionStorage.getItem('token'),
        company_id:sessionStorage.getItem('company_id'),
      };
      this.$axios.getAliJson(param).then(res=>{
        console.log('ali_json------',res)
        let data=res['data'];
        console.log(data);
        let suffix = _this.get_suffix(file.name);
        let autoname = _this.Ymdhis();
        let key = data['dir'];
        let  host = data['host'];

        let request = new FormData();
        request.append('name', file.name);
        request.append("key", key +'mrh/'+ autoname + suffix);//文件名字，可设置路径
        request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
        request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
        request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
        request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
        request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
        request.append('file', file);//需要上传的文件 file
        console.log('file=------',file)
        axios.post('/alioss',request,{headers:{'Content-Type':'multipart/form-data'}}).then(res => {
          console.log('upload -res--------',res)
          var fileurl = res.data.filename; //上传完成后的文件oss地址
          var fullurl=host+'/'+fileurl;
          setTimeout(function(){
            insertFn(fullurl); //插入地址
          },2000);
        })
            .catch(error =>
                console.log(error)
            )
      });
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    get_suffix(filename) {
      let pos = filename.lastIndexOf('.')
      let suffix = ''
      if (pos != -1) {
        suffix = filename.substring(pos)
      }
      return suffix;
    },
    Ymdhis(){
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth()+1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      return ''+year+month+day+hour+minute+second;
    },
    urlParse(_url = '') {
      let url_obj = new URL(_url || window.location.href);
      let search_path = url_obj.search;
      let handle_path = decodeURIComponent(search_path.substr(1));

      let handle_path_arr = handle_path.split('&');
      let search_params = {};
      for(let item of handle_path_arr) {
        let r = item.split('=');
        search_params[r[0]] = r[1];
      }
      return {
        protpcol: url_obj.protocol,
        search: url_obj.search,
        host: url_obj.host,
        port: url_obj.port,
        pathname: url_obj.pathname,
        searchParams: search_params
      }
    },
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
};
</script>

<style>
/deep/ .input__inner{color:#333}
.w-e-modal{z-index: 999 !important;left: 300px !important;top: 300px !important;}
.main_image img {
  width: 100px; /* 设置图片宽度 */
  height: 100px; /* 设置图片高度 */
  display: block;
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>